import Amex from './Amex';

export default Amex;
